import Http from './../http';

const prefix = '/restrict-area';

var softCache = [];

export const getTypes = () => {
  if (!softCache['get-types'])
    softCache['get-types'] = Http.authApi().get(`${prefix}/types/all`);

  return softCache['get-types'];
};

export const getAll = (id) => Http.authApi().get(`${prefix}/all/${id}`);

export const getPagesAll = (id) => Http.authApi().get(`${prefix}/pages/all/${id}`);

export const get = ({ id }) => Http.authApi().get(`${prefix}/${id}`);

export const create = restrictArea => Http.authApi().post(`${prefix}`, restrictArea);

export const edit = restrictArea => {
  return Http.authApi().put(`${prefix}/${restrictArea.id}`, restrictArea)
}

export const exclude = restrictArea =>
  Http.authApi().delete(`${prefix}/${restrictArea.id}/${restrictArea.website_id}`, restrictArea);



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/restrictArea.js